import {
  SCOOTER_TRIP_ACTIVE_LOADING,
  SCOOTER_TRIP_ACTIVE_ERROR,

  SCOOTER_TRIP_ACTIVE_LIST,
  SCOOTER_TRIP_ACTIVE_FILTERS,
  SCOOTER_TRIP_ACTIVE_FINISH
} from "actions/scooter/trip-active/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
  filters: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SCOOTER_TRIP_ACTIVE_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case SCOOTER_TRIP_ACTIVE_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case SCOOTER_TRIP_ACTIVE_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case SCOOTER_TRIP_ACTIVE_FILTERS:
      return {
        ...state,
        loading: false,
        errors: [],
        filters: action.payload.content,
      };
    case SCOOTER_TRIP_ACTIVE_FINISH:
      return {
        ...state,
        list: {
          ...state.list,
          content: (state.list.content || []).filter(item => item.id !== action.payload)
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/scooterTripActiveReducer.js